import { graphql, useStaticQuery } from "gatsby";
import { CruisePerDestinationCountsQuery } from "types/graphql-types";

export type CruisePerDestinationCounts2Result = Record<
  string,
  { classic: number; expedition: number } | undefined
>;

export const useCruisePerDestinationCounts = (
  enable: boolean
): CruisePerDestinationCounts2Result => {
  const cruises = useStaticQuery<CruisePerDestinationCountsQuery>(graphql`
    query CruisePerDestinationCounts {
      allSanityCruiseData(filter: { isVisible: { eq: true } }) {
        group(field: { destination: { destinationWebCode: SELECT } }) {
          fieldValue
          group(field: { cruiseType: SELECT }) {
            fieldValue
            totalCount
          }
        }
      }
    }
  `);

  if (!enable) return {};

  return cruises.allSanityCruiseData.group.reduce((acc, destination) => {
    const { fieldValue, group } = destination;
    if (!fieldValue) return acc;

    const countClassic =
      group.find((cruiseType) => cruiseType.fieldValue === "Classic")
        ?.totalCount || 0;
    const countExpedition =
      group.find((cruiseType) => cruiseType.fieldValue === "Expedition")
        ?.totalCount || 0;

    acc[fieldValue] = {
      classic: countClassic,
      expedition: countExpedition
    };

    return acc;
  }, {});
};
